import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as SonnerToaster, toast } from 'sonner';
/**
 * EmanetX brand'i ile uyumlu Sonner Toaster sarmalayicisi.
 * web-admin / web-musteri / web-partner / web-status — main.tsx'te bir kere mount edilir.
 */
export function Toaster({ karanlik = false }) {
    return (_jsx(SonnerToaster, { position: "top-right", richColors: false, closeButton: true, theme: karanlik ? 'dark' : 'light', toastOptions: {
            classNames: {
                toast: 'group toast group-[.toaster]:bg-white group-[.toaster]:text-fume-900 group-[.toaster]:border-fume-200 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-fume-900 dark:group-[.toaster]:text-fume-50 dark:group-[.toaster]:border-fume-800',
                description: 'group-[.toast]:text-fume-500 dark:group-[.toast]:text-fume-400',
                actionButton: 'group-[.toast]:bg-marka-500 group-[.toast]:text-fume-900 group-[.toast]:hover:bg-marka-600',
                cancelButton: 'group-[.toast]:bg-fume-100 group-[.toast]:text-fume-700 dark:group-[.toast]:bg-fume-700 dark:group-[.toast]:text-fume-100',
                success: 'group-[.toaster]:border-emerald-200 dark:group-[.toaster]:border-emerald-900',
                error: 'group-[.toaster]:border-red-200 dark:group-[.toaster]:border-red-900',
            },
        } }));
}
export { toast };
//# sourceMappingURL=toaster.js.map